export enum SourceSystemEnum {
  CRED_DEFENSE = "CRED_DEFENSE",
  UNICO = "UNICO"
}



// WEBPACK FOOTER //
// ./src/services/Enum/credDefense/SourceSystemEnum.ts